<script setup lang="ts">
import { cn } from '@laam/lib/utils';
import { PhCaretDown } from '@phosphor-icons/vue';
import {
	type PrimitiveProps,
	SelectIcon,
	SelectTrigger,
	useForwardProps,
} from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';
import { selectVariants, type SelectVariants } from '.';

interface Props extends PrimitiveProps {
	class?: HTMLAttributes['class'];
	size?: SelectVariants['size'];
	disabled?: boolean;
	hasError?: boolean;
}

const props = defineProps<Props>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectTrigger
		v-bind="forwardedProps"
		:class="cn(selectVariants({ size, hasError }), props.class)"
	>
		<slot />
		<SelectIcon as-child>
			<PhCaretDown class="w-3xl h-3xl opacity-50" />
		</SelectIcon>
	</SelectTrigger>
</template>
